/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для персональных рекомендаций в категориях 2 уровня
   */
  app.PersonalRecommendationsCategoryView = app.PersonalRecommendationsView.extend({
    MIN_ITEMS_QTY_ON_PAGE_REQUIRED: 20,
    shouldShowRecommendations: true,
    shouldFetchNewItems: false,
    /**
     * @inheritDoc
     */
    run: function () {
      app.PersonalRecommendationsView.prototype.run.apply(this);
      this.listenTo(Backbone, 'new-items-on-page', this.updateRecommendation);
    },

    /**
     * Обновление рекомендаций в категориях
     * @param {number} amountItems количество товаров
     */
    updateRecommendation: function (amountItems) {
      if (amountItems < this.MIN_ITEMS_QTY_ON_PAGE_REQUIRED) {
        this.shouldShowRecommendations = false;
        this.$el.addClass("not_display");
      } else {
        this.shouldShowRecommendations = true;
        this.$el.removeClass("not_display");
        if (this.shouldFetchNewItems && this.$el.children().length > 0) {
          this.model.fetch();
          this.shouldFetchNewItems = false;
        }
      }
    },

    /**
     * @inheritDoc
     */
    shouldInitialise: function () {
      if (this.shouldShowRecommendations) {
        app.PersonalRecommendationsView.prototype.shouldInitialise.call(this);
      }
    },

    /**
     * @inheritDoc
     */
    fetchNewPrices: function (currency) {
      if (this.shouldShowRecommendations) {
        app.PersonalRecommendationsView.prototype.fetchNewPrices.apply(this, arguments);
      } else {
        _.extend(this.model.requestParameters, { currency: currency.get('name') });
        this.shouldFetchNewItems = true;
      }
    }
  });
})();

}.call(window));